import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { HttpClientModule } from '@angular/common/http';

import { MaterialModule } from '../../../material.module';
import { MapboxPlaceInputModule } from '../mapbox-place-input/mapbox-place-input.module';
import { CountryAutocompleteModule } from './../country-autocomplete/country-autocomplete.module';
import { AddressMapboxComponent } from './address-mapbox.component';

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    HttpClientModule,
    MaterialModule,
    TranslateModule.forChild(),
    MapboxPlaceInputModule,
    CountryAutocompleteModule
  ],
  declarations: [AddressMapboxComponent],
  exports: [AddressMapboxComponent]
})
export class AddressMapboxModule {}

